import { Arrange, Text } from '@loomhq/lens';
import React, { useMemo } from 'react';

import { getCloudfrontURI } from 'utilities/avatar';

import UserAvatar from 'components/user-avatar';

const MentionSuggestion = ({ user }) => {
  const userAvatarSrc = useMemo(() => {
    return user.avatar && getCloudfrontURI(user.avatar);
  }, [user.avatar]);

  return (
    <Arrange justifyContent="start" alignItems="center" gap="small">
      <UserAvatar
        avatarSrc={userAvatarSrc}
        name={user.display}
        avatarSize={3}
      />
      <Text size="medium" fontWeight="bold" color="white">
        {user.display}
      </Text>
    </Arrange>
  );
};

export default MentionSuggestion;
